import { makeStyles } from "@mui/styles"

export const useFilterButtonStyles = makeStyles(() => ({
  counterContainer: {
    background: "#6B546A",
    borderRadius: "50%",
    color: "#F2F2F5",
    fontSize: "12px",
    height: "20px",
    lineHeight: "20px",
    pointerEvents: "none",
    position: "absolute",
    right: "14px",
    textAlign: "center",
    top: "12px",
    width: "20px",
  },
  filterButtonContainer: {
    "& button": {
      paddingRight: "42px !important",
    },
    position: "relative",
  },
  filterPopover: {
    border: "1px solid #ECECEC",
    boxShadow: "none",
    maxWidth: "450px"
  },
}))
